import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import Messages from '../screens/MidLevel/MessageScreen/Messages';
import ComingSoonScreen from '../screens/NonMenu/ComingSoonScreen';
import { MessageNavigatorParamList } from '../types';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';

const MessageStack = createStackNavigator<MessageNavigatorParamList>();

const MessageNavigator = () => {
  const theme = themeSelector();
  return (
    <MessageStack.Navigator
      screenOptions={{ 
        headerShown: false, 
        cardStyle: { backgroundColor: theme ? "white" : "black" },
        freezeOnBlur: true 
      }}
      initialRouteName="Messages"
    >
      <MessageStack.Screen
        name="Messages"
        component={Messages}
        options={{ headerTitle: 'Messages' }} 
      />
      <MessageStack.Screen
        name="Internal"
        component={Messages}
        options={{ headerTitle: 'Internal Messages' }} 
      />
      <MessageStack.Screen
        name="External"
        component={Messages}
        options={{ headerTitle: 'External Messages' }} 
      />
    </MessageStack.Navigator>
  );
}

export { MessageStack, MessageNavigator };
